import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {
    Switch,
    Route,
    NavLink,
    useRouteMatch,
    Redirect
} from "react-router-dom";
import IconSite from '../../IconSite';
import _ from 'lodash';
import FlashcardSelfTexte from './FlashcardSelfTexte';
import FlashcardMultiTexte from './FlashcardMultiTexte';

import { chooseGame } from '../../../redux/actions/gameTexteActions';

function FlashcardsTexte() {

    const gameTexte = useSelector(state => state.gameTexte);
    const { game_choice } = gameTexte;

    let [gameChoose, setGameChoose] = useState(game_choice);

    const dispatch = useDispatch();

    let { path, url } = useRouteMatch();

    const showSolution = (game) => {
        dispatch(chooseGame(game));
        setGameChoose(game);
    }

    return (

        <section className="flashcards" >

            <ul className="flashcards__menu" >
                <li >
                    <NavLink to={`${url}/flashcardSelf`} onClick={() => showSolution("/flashcardSelf")}>
                        {gameChoose === "/flashcardSelf" ? <span className="material-icons green md-36">done_outline</span>
                            : <span className="material-icons md-36 md-light">done_outline</span>
                        }
                    </NavLink>
                </li>
                <li>
                    <NavLink to={`${url}/flashcardMult`} onClick={() => showSolution("/flashcardMult")}>
                        {gameChoose === "/flashcardMult" ? <span className="material-icons green md-36">grading</span>
                            : <span className="material-icons md-36 md-light">grading</span>
                        }
                    </NavLink>
                </li>
            </ul>

            <Switch>
                <Route exact path={path}>
                    {game_choice === '/flashcardMult' ? <Redirect to={`${path}/flashcardMult`} /> :
                        game_choice === '/flashcardLink' ? <Redirect to={`${path}/flashcardLink`} /> :
                            game_choice === '/flashcardWrite' ? <Redirect to={`${path}/flashcardWrite`} /> :
                                <Redirect to={`${path}/flashcardSelf`} />
                    }
                </Route>
                <Route path={`${path}/flashcardSelf`}>
                    <FlashcardSelfTexte />
                </Route>
                <Route path={`${path}/flashcardMult`}>
                    <FlashcardMultiTexte />
                </Route>
            </Switch>

        </section>
    )
}

export default FlashcardsTexte
